module.exports = __webpack_public_path__ + "assets/img/35@3x.418d8060.png";